import React, { useState, createContext, useEffect } from "react";
import sofadata from "./sofadata.json";
import Filter from "./Filter";
import List from "./List";

export const Data = createContext();

const App = () => {
  const [favFilter, setFavFilter] = useState(
    window.location.search.includes("bookmark") ? true : false
  );
  const [favList, setFavList] = useState([]);
  const [rawData, setRawData] = useState(sofadata);
  const [data, setData] = useState(rawData);
  const value = {
    rawData,
    data,
    setData,
    favList,
    setFavList,
    favFilter,
    setFavFilter,
  };

  useEffect(() => {
    // ソファリスト取得
    fetch("/api/sofadata.php?type=all")
      .then((res) => res.json())
      .then((data) => setRawData(data))
      .catch((err) => console.error(err));

    // お気に入りリスト取得
    fetch("/api/bookmark.php?type=list", { cache: "no-cache" })
      .then((res) => res.json())
      .then((arr) => {
        return arr.map((item) => {
          return item.split("_")[0];
        });
      })
      .then((data) => setFavList(data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <>
      <Data.Provider value={value}>
        <Filter />
        <List />
      </Data.Provider>
    </>
  );
};

export default App;
